import { render, staticRenderFns } from "./GisDatasetComparison.vue?vue&type=template&id=825dbb62&scoped=true"
import script from "./GisDatasetComparison.vue?vue&type=script&lang=js"
export * from "./GisDatasetComparison.vue?vue&type=script&lang=js"
import style0 from "./GisDatasetComparison.vue?vue&type=style&index=0&id=825dbb62&prod&scoped=true&lang=css"
import style1 from "./GisDatasetComparison.vue?vue&type=style&index=1&id=825dbb62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825dbb62",
  null
  
)

export default component.exports